import { render, staticRenderFns } from "./CorCarryGuide.vue?vue&type=template&id=634a3360&"
import script from "./CorCarryGuide.vue?vue&type=script&lang=js&"
export * from "./CorCarryGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports